import { baseKeys } from './base'

export default function keys(data) {
  return baseKeys(data)
}
